import React, { useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./HomeBanner.css";

const images = [
  "https://homehelpershomecare.com/wp-content/uploads/2024/04/banner-akron.jpg",
  "https://homehelpershomecare.com/wp-content/uploads/2024/04/banner-akron.jpg",
  "https://homehelpershomecare.com/wp-content/uploads/2024/04/banner-akron.jpg",
];

const HomeBanner = () => {
  const [currentImage, setCurrentImage] = useState(images[0]);
  const [currentText, setCurrentText] = useState({
    title: "Your Health And Home Care Needs, Always Our Priority",
    description:
      "We believe in providing personalized, caring support for all your healthcare and home care needs. Whether you’re managing a health condition or require assistance at home, our dedicated team is here to help.",
  });

  const imageData = images.map((src) => ({
    src,
    title: "Your Health And Home Care Needs, Always Our Priority",
    description:
      "We believe in providing personalized, caring support for all your healthcare and home care needs. Whether you’re managing a health condition or require assistance at home, our dedicated team is here to help.",
  }));

  const handleImageChange = (imageIndex) => {
    const selectedImage = imageData[imageIndex];
    setCurrentImage(selectedImage.src);
    setCurrentText({
      title: selectedImage.title,
      description: selectedImage.description,
    });
  };

  return (
    <div className="HomeBanner">
      <img src={currentImage} alt="Banner" className="HomeBanner-image" />

      <div className="HomeBanner-overlay">
        <Container>
          <Row className="justify-content-start container-fluid">
            <Col
              lg={12}
              md={10}
              sm={12}
              className="mt-5"
              style={{ textAlign: "center", marginTop: "250px" }}
            >
              <h1 className="HomeBanner-title">{currentText.title}</h1>
              <p className="HomeBanner-description">
                {currentText.description}
              </p>
            </Col>
          </Row>

          <Row className="justify-content-start mt-5 container-fluid">
            <Col lg={12} md={10} sm={12} style={{ textAlign: "center" }}>
              <div className="HomeBanner-buttons">
                <Button
                  variant="outline-light"
                  size="lg"
                  className="HomeBanner-btn"
                  onClick={() => {
                    document
                      .getElementById("prefooterform")
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                >
                  Join us on your journey
                </Button>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default HomeBanner;
